module.exports = {"350504001":"万安街道","350504002":"双阳街道","350504100":"罗溪镇","350504101":"马甲镇","350504102":"河市镇","350504200":"虹山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350504.json
// module id = 1103
// module chunks = 0